/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type GeminiReponse = {
  __typename?: 'GeminiReponse';
  answer: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addEntryToTrip: Scalars['Boolean'];
  createTraveller: Scalars['Boolean'];
  createTrip: Scalars['Boolean'];
  likePlace: Scalars['Boolean'];
  removeEntryFromTrip: Scalars['Boolean'];
  setStartviewpoint: Scalars['Boolean'];
  unlikePlace: Scalars['Boolean'];
};


export type MutationAddEntryToTripArgs = {
  order: Scalars['Int'];
  tripId: Scalars['String'];
  wikientryUid: Scalars['String'];
};


export type MutationCreateTravellerArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationCreateTripArgs = {
  name: Scalars['String'];
  private: Scalars['Boolean'];
};


export type MutationLikePlaceArgs = {
  wikientryUid: Scalars['String'];
};


export type MutationRemoveEntryFromTripArgs = {
  tripId: Scalars['String'];
  wikientryUid: Scalars['String'];
};


export type MutationSetStartviewpointArgs = {
  wikientryUid: Scalars['String'];
};


export type MutationUnlikePlaceArgs = {
  wikientryUid: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  askGemini: GeminiReponse;
  currentUser: Traveller;
  dumpDB: Scalars['String'];
  isAuth: Scalars['Boolean'];
  login: Scalars['Boolean'];
  logout: Scalars['Boolean'];
  trip: Trip;
  trips: Array<Trip>;
  wikientries: Array<Wikientry>;
  wikientriesAutocomplete: Array<Wikientry>;
  wikientry: Wikientry;
  wikisbyviewport: Array<Wikientry>;
};


export type QueryAskGeminiArgs = {
  question: Scalars['String'];
};


export type QueryLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type QueryTripArgs = {
  uid: Scalars['String'];
};


export type QueryWikientriesAutocompleteArgs = {
  input: WikiSearchInput;
};


export type QueryWikientryArgs = {
  searchTerm: Scalars['String'];
};


export type QueryWikisbyviewportArgs = {
  input: WikisByViewportInput;
};

export type StatusByFilter = {
  city?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['Boolean']>;
  district?: InputMaybe<Scalars['Boolean']>;
  park?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['Boolean']>;
};

export type Traveller = {
  __typename?: 'Traveller';
  likedPlaces?: Maybe<Array<Wikientry>>;
  startViewpoint?: Maybe<Wikientry>;
  trips?: Maybe<Array<Trip>>;
  uid: Scalars['String'];
  username: Scalars['String'];
};

export type TravellerWhoLikesThisTrip = {
  __typename?: 'TravellerWhoLikesThisTrip';
  uid: Scalars['String'];
};

export type Trip = {
  __typename?: 'Trip';
  name: Scalars['String'];
  private?: Maybe<Scalars['Boolean']>;
  travellers?: Maybe<Array<TravellerWhoLikesThisTrip>>;
  tripentries?: Maybe<Array<Tripentry>>;
  uid: Scalars['String'];
};

export type Tripentry = {
  __typename?: 'Tripentry';
  ispartof: Scalars['String'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  order: Scalars['Int'];
  status: Scalars['String'];
  title: Scalars['String'];
  uid: Scalars['String'];
  wikipageid: Scalars['Int'];
  zoom: Scalars['Int'];
};

export type WikiSearchInput = {
  searchTerm: Scalars['String'];
};

export type Wikientry = {
  __typename?: 'Wikientry';
  ispartof: Scalars['String'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  status: Scalars['String'];
  title: Scalars['String'];
  uid: Scalars['String'];
  wikipageid: Scalars['Int'];
  zoom: Scalars['Int'];
};

export type WikisByViewportInput = {
  maxLat: Scalars['Float'];
  maxLon: Scalars['Float'];
  minLat: Scalars['Float'];
  minLon: Scalars['Float'];
  statusByFilter?: InputMaybe<StatusByFilter>;
  zoom: Scalars['Int'];
};

export type AskGeminiQueryVariables = Exact<{
  question: Scalars['String'];
}>;


export type AskGeminiQuery = { __typename?: 'Query', askGemini: { __typename?: 'GeminiReponse', answer: string } };

export type WikisbyviewportQueryVariables = Exact<{
  min_lon: Scalars['Float'];
  max_lon: Scalars['Float'];
  min_lat: Scalars['Float'];
  max_lat: Scalars['Float'];
  zoom: Scalars['Int'];
  statusByFilter?: InputMaybe<StatusByFilter>;
}>;


export type WikisbyviewportQuery = { __typename?: 'Query', wikisbyviewport: Array<{ __typename?: 'Wikientry', uid: string, title: string, status: string, lat: number, lon: number, wikipageid: number }> };

export type WikientriesAutocompleteQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type WikientriesAutocompleteQuery = { __typename?: 'Query', wikientriesAutocomplete: Array<{ __typename?: 'Wikientry', title: string, uid: string, lat: number, lon: number, status: string, wikipageid: number }> };

export type IsAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type IsAuthQuery = { __typename?: 'Query', isAuth: boolean };

export type LoginQueryVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginQuery = { __typename?: 'Query', login: boolean };

export type LogoutQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoutQuery = { __typename?: 'Query', logout: boolean };

export type CreateTravellerMutationVariables = Exact<{
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreateTravellerMutation = { __typename?: 'Mutation', createTraveller: boolean };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'Traveller', uid: string, username: string, likedPlaces?: Array<{ __typename?: 'Wikientry', uid: string, wikipageid: number, title: string, lat: number, lon: number, zoom: number, status: string, ispartof: string }> | null, startViewpoint?: { __typename?: 'Wikientry', uid: string, wikipageid: number, title: string, lat: number, lon: number, zoom: number, status: string, ispartof: string } | null, trips?: Array<{ __typename?: 'Trip', uid: string, name: string }> | null } };

export type LikePlaceMutationVariables = Exact<{
  wikientryUid: Scalars['String'];
}>;


export type LikePlaceMutation = { __typename?: 'Mutation', likePlace: boolean };

export type UnlikePlaceMutationVariables = Exact<{
  wikientryUid: Scalars['String'];
}>;


export type UnlikePlaceMutation = { __typename?: 'Mutation', unlikePlace: boolean };

export type SetStartviewpointMutationVariables = Exact<{
  wikientryUid: Scalars['String'];
}>;


export type SetStartviewpointMutation = { __typename?: 'Mutation', setStartviewpoint: boolean };


export const AskGeminiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"askGemini"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"question"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askGemini"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"question"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]} as unknown as DocumentNode<AskGeminiQuery, AskGeminiQueryVariables>;
export const WikisbyviewportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Wikisbyviewport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"min_lon"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_lon"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"min_lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statusByFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusByFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wikisbyviewport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"minLat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"min_lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxLat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minLon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"min_lon"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxLon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_lon"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"zoom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"statusByFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statusByFilter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}},{"kind":"Field","name":{"kind":"Name","value":"wikipageid"}}]}}]}}]} as unknown as DocumentNode<WikisbyviewportQuery, WikisbyviewportQueryVariables>;
export const WikientriesAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"wikientriesAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wikientriesAutocomplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"wikipageid"}}]}}]}}]} as unknown as DocumentNode<WikientriesAutocompleteQuery, WikientriesAutocompleteQueryVariables>;
export const IsAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isAuth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAuth"}}]}}]} as unknown as DocumentNode<IsAuthQuery, IsAuthQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<LoginQuery, LoginQueryVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutQuery, LogoutQueryVariables>;
export const CreateTravellerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTraveller"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTraveller"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<CreateTravellerMutation, CreateTravellerMutationVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"likedPlaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"wikipageid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ispartof"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startViewpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"wikipageid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ispartof"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const LikePlaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"likePlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wikientryUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likePlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wikientryUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wikientryUid"}}}]}]}}]} as unknown as DocumentNode<LikePlaceMutation, LikePlaceMutationVariables>;
export const UnlikePlaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unlikePlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wikientryUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlikePlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wikientryUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wikientryUid"}}}]}]}}]} as unknown as DocumentNode<UnlikePlaceMutation, UnlikePlaceMutationVariables>;
export const SetStartviewpointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setStartviewpoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wikientryUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setStartviewpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wikientryUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wikientryUid"}}}]}]}}]} as unknown as DocumentNode<SetStartviewpointMutation, SetStartviewpointMutationVariables>;